:host {
    display: flex;
    flex-direction: column;

    @media (min-width: 600px) and (max-width: 1024px) {
        display: block;
    }
}

a {
    color: currentcolor;
}

.base-price-info.detail {
    padding-bottom: 0.3rem;

    @media (min-width: 600px) and (max-width: 1024px) {
        padding-bottom: 0;
    }
}

.product-price {
    color: var(--vx-price-unit-price-text-color, black);
    font-size: var(--vx-price-unit-price-font-size, 2.25rem);
    padding-right: 2rem;
}

.detail {
    font-size: var(--vx-price-detail-font-size, .75rem);
    font-weight: var(--vx-price-detail-font-weight, 400);
    line-height: var(--vx-price-detail-line-height, .88rem);
    color: var(--vx-price-detail-text-color, #908787);
    text-wrap: balance;
}

.pseudo-price {
    line-height: 0.9rem;
    height: 0.9rem;
    font-size: 0.9rem;
    text-decoration: line-through;
    color: var(--vx-price-detail-text-color, #908787);
}

.with-pseudo .product-price {
    color: var(--vx-price-unit-pseudo-price-text-color, #ea5659);
}

.minimal-layout {
    font-size: 0.75rem;
    color: var(--vx-price-detail-text-color, #908787);

    div.product-price {
        font-size: var(--vx-price-detail-minimal-price-font-size, 1.375rem);
    }

    .reference-unit {
        color: var(--vx-price-reference-unit-text-color, #908787);
    }
}
